export const topModes = [
  { label: 'Volume', value: 'mode_Volume' },
  { label: 'Time', value: 'mode_Time' },
  { label: 'Volume/area', value: 'mode_MM' },
  { label: 'DryContact', value: 'mode_DryContact' },
  { label: 'Stop', value: 'mode_Stop' },
  { label: 'Virtual', value: 'mode_Virtual' },
];

export const modesOptions = {
  mode_Volume: [
    {
      label: 'M3',
      value: 'Volume',
    },
    {
      label: 'Liter',
      value: 'Liter',
    },
  ],
  mode_Time: [{ label: 'Seconds', value: 'Time' }],
  mode_MM: [
    { label: 'mm', value: 'MM' },
    { label: 'L/M2', value: 'MM_LM2' },
    { label: 'M3/Dunam', value: 'MM_M3Dunam' },
    { label: 'M3/Hectare', value: 'M3H' },
  ],
  mode_DryContact: [{ label: 'Seconds', value: 'Seconds' }], // {mode_dryContact: "DryContact", value: 5}
};

export const modeToLabel = (modeEntity: any): string => {
  if (typeof modeEntity === 'object') {
    const paramModeValues = Object.keys(modeEntity);
    const foundMode = topModes.find((modeObject) =>
      paramModeValues.includes(modeObject.value),
    );

    return foundMode?.label || '';
  }

  return modeEntity;
}

export const staticModes = {
  mode_Stop: 'Stop', // No value in with object mode: {mode_stop: "Stop"}
  mode_Virtual: 'Virtual', // No value in with object mode: {mode_virtual: "Virtual"}
};

export const staticWithValueModes = {
  mode_DryContact: 'DryContact',
}
